/**
 * See the NOTICE file distributed with this work for additional information
 * regarding copyright ownership.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { memo } from 'react';
import classNames from 'classnames';
import upperFirst from 'lodash/upperFirst';

import styles from './CircleLoader.module.css';

type Size = 'default' | 'small';

type Props = {
  className?: string;
  size?: Size;
};

const CircleLoader = (props: Props) => {
  const loaderSize = props.size ?? 'default';
  const className = classNames(
    styles.circleLoader,
    styles[`circleLoader${upperFirst(loaderSize)}`],
    props.className
  );

  return (
    <div className={className}>
      <div className={styles.spinner} />
    </div>
  );
};

export default memo(CircleLoader);
